const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  name: state => state.user.name,
  title: state => state.settings.title,
  x86Type: state => state.user.x86Type,
  privacyAgreementVersion: state => state.user.privacyAgreementVersion,
  isHaveThor: state => state.user.isHaveThor,
  isWhiteAuth: state => state.user.isWhiteAuth,
  isNameAuth: state => state.user.isNameAuth
}
export default getters
